

import Captcha from './captcha' //验证码

function myRandom(max, min){
    return Math.round(Math.random() * (max - min) + min); //随机范围数字
}
function randomNum(){
    let str = "";

   for(let i = 0; i < 10; i++){
       //循环几次无所谓 也可以是100次  随机字符库
        let lowerCase = String.fromCharCode(Math.random() * 26 + 97); //随机小写字母
        let upperCase = String.fromCharCode(Math.random() * 26 + 65); //大写字母
        let rdm = myRandom(0, 9);//0-9随机

        str += lowerCase + upperCase + rdm; 
   }

   let strData = "";
    for(let y = 0; y < 10; y++){
        //开始真正随机  从随机字符库随机取出0个
        strData += str[myRandom(0, str.length - 1)];
    }

    return strData;
}

let captchaVal = randomNum() || 'nE7jAp5mE2'
let captcha1 = new Captcha({
    fontSize:35,
    content:captchaVal,
    backGroundColor:[232, 240, 254],
    length: captchaVal.length + 1
});

export default function (nodeName,isChange) {

    captchaVal = randomNum()
    if(isChange) captcha1.clear()
    captcha1 = new Captcha({
        fontSize:35,
        content:captchaVal,
        backGroundColor:[232, 240, 254],
        length: captchaVal.length + 1
    });
    captcha1.draw(document.querySelector(nodeName))
    
    return captchaVal
}

